export default __webpack_public_path__ + "static/media/purple-horizontal-bars.49e2c9f5.svg";